const validationMessages = {
	CAPTCHA_EXPIRED: "Couldn't verify CAPTCHA, please try again",
	CAPTCHA_MANDATORY: 'Please verify CAPTCHA to resend OTP',
	CAPTCHA_MANDATORY_LOGIN: 'Please verify CAPTCHA to continue',
	EMAIL_MANDATORY: 'Please enter a valid Email to continue.',
	EMAIL_INVALID: 'Invalid Email, please try again',
	PASSWORD_MANDATORY: 'Please enter your Password to continue',
	PASSWORD_CONFIRM_MANDATORY: 'Please confirm your password!',
	PASSWORD_MISMATCH: 'The two passwords that you entered do not match!',
	PASSWORD_MIN_ERROR: 'Password must have at least 8 characters.',
	MOBILE_MANDATORY: 'Please enter your Phone no. to continue',
	MOBILE_INVALID: 'Invalid Phone Number, please try again',
	MOBILE_REGEX_INVALID: 'Mobile number must be number only',
	MOBILE_LENGTH_INVALID: 'Mobile number must be 10 digits',
	INTERNATIONAL_MOBILE_INVALID:
		'Please enter valid e164 format phone number (7 to 15 digits), without spaces & brackets',
	OTP_MANDATORY: 'Please enter OTP sent to your Phone to continue',
	MIN_OTP_ERROR: 'Must be exactly 5 digits.',
	OTP_REGEX_INVALID: 'Must be only digits',
};

export default validationMessages;
